import { render, staticRenderFns } from "./Space.vue?vue&type=template&id=61f91db0&scoped=true"
import script from "./Space.vue?vue&type=script&lang=js"
export * from "./Space.vue?vue&type=script&lang=js"
import style0 from "./Space.vue?vue&type=style&index=0&id=61f91db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f91db0",
  null
  
)

export default component.exports